var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{attrs:{"id":0,"name":_vm.nameLabel,"type":_vm._f("capitalize")(_vm.$tc('models.network', 1)),"showBackButton":_vm.showBackButton},on:{"backButtonPressed":_vm.clickBack},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('MapIcon',_vm._b({attrs:{"size":39}},'MapIcon',_vm.networkIcon,false))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }